import React from 'react';
import { Form } from 'react-final-form';
import { useSelector } from 'react-redux';
import useEmailUpdate from 'Hooks/User/useEmailUpdate';
import { UpdateEmailPayload } from 'Interfaces/Profile';
import Toast from 'Services/Toast';
import { selectUser } from 'Utils/selectors';

import ChangeEmailFields from './ChangeEmailFields';

export interface ChangeEmailFormFieldProps {
  isUser: boolean;
  isAppSumo: boolean;
}

const ChangeEmailForm = ({ isUser, isAppSumo }: ChangeEmailFormFieldProps) => {
  const { email } = useSelector(selectUser);
  const [updateEmail, isEmailUpdating] = useEmailUpdate();

  const handleUpdateEmail = async (values: UpdateEmailPayload) => {
    try {
      await updateEmail(values);

      Toast.success('Check your new email to confirm it');
    } catch (err) {
      Toast.handleErrors(err);
    }
  };

  return (
    <Form
      keepDirtyOnReinitialize
      initialValues={
        {
          email: email as string,
        } as UpdateEmailPayload
      }
      onSubmit={handleUpdateEmail}
      render={({
        handleSubmit,
        submitting,
        hasValidationErrors,
        pristine,
        values,
        form,
      }) => (
        <ChangeEmailFields
          handleSubmit={handleSubmit}
          isDisabled={pristine || submitting || hasValidationErrors || isEmailUpdating}
          isFieldDisabled={isUser}
          emailValue={values.email}
          form={form}
          isAppSumo={isAppSumo}
        />
      )}
    />
  );
};

export default ChangeEmailForm;
